import { useEffect, useRef } from "react";
import { User } from "interfaces/user";
import { initializeTrengoWidget, setTrengoContactData } from "utils/trengo";

/**
 * Hook that initializes and syncs user contact data with the Trengo widget
 * - Initializes the widget script when user first logs in
 * - Updates contact data with user information
 */
export const useTrengoSync = (user: User | null): void => {
	const hasInitialized = useRef(false);

	useEffect(() => {
		if (user && !hasInitialized.current) {
			// Initialize widget only once when user logs in
			initializeTrengoWidget();
			hasInitialized.current = true;
		}

		// Set/update contact data whenever user changes
		setTrengoContactData(user);
	}, [user]);
};
